import VerifyOutReplacementDelivery from "../../../../components/@documents/replacement_delivery/VerifyOutReplacementDelivery";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ReplacementDeliveryVerifyOutPage() {

    return (
        <VerifyOutReplacementDelivery 
            routeType={routeTypes.workstation}
        />
    )
}